import React from "react";
import {
  Container,
  Typography,
  Box,
  Stack,
  Button,
  ButtonBase,
  Link,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import { Link as ReactRouterLink } from "react-router-dom";
import LogoLargeLight from "../assets/LogoLargeLight.svg";
import LogoLargeDark from "../assets/LogoLargeDark.svg";

// A personal, URL-only page — deliberately not linked from any nav or sitemap.
// Reachable only via the exact link (shared as a QR code), never via ProtectedRoute.
const RichardOsman = () => {
  const theme = useTheme();
  return (
    <Container maxWidth="sm" sx={{ mt: 4, mb: 4, px: { xs: 3 } }}>
      <Box display="flex" justifyContent="flex-end">
        <ButtonBase component={ReactRouterLink} to="/?redirect=false">
          <img
            src={theme.palette.mode === "dark" ? LogoLargeDark : LogoLargeLight}
            alt="Curate Logo"
            width="150px"
          />
        </ButtonBase>
      </Box>

      <Typography variant="body1" gutterBottom sx={{ mt: 4, mb: 2 }}>
        <strong>
          My Very Own Project Hail Mary: Ask Richard Osman for help building the
          best book, film &amp; TV discovery app around...{" "}
        </strong>
      </Typography>

      <Typography
        variant="body1"
        paragraph
        gutterBottom
        sx={{ textAlign: "justify" }}
      >
        Hello Sir,
      </Typography>

      <Typography variant="body1" paragraph sx={{ textAlign: "justify" }}>
        I, like you, am a big lover of books, TV and films. A slightly odd
        pairing with the other half of my brain, which has a physics degree from
        Imperial. Somewhere between the two I ended up building Curate: a single
        place to track everything you watch and read. Think Letterboxd, but for
        books and TV as well as movies. Curate is entirely self-built and
        self-funded. No investors, just me and 500+ users across 30+ countries,
        with new users joining every day.
      </Typography>

      <Typography variant="body1" paragraph sx={{ textAlign: "justify" }}>
        You're honestly the person I had in mind while building it. What I love
        about what you do is that you're connecting people (a lot of them from
        my generation) to a wider shared culture and zeitgeist, which feels
        genuinely rare these days. That's basically Curate's whole mission too:
        it's anti-traditional social media (no ads, no algorithms), built purely
        to help bookworms, cinephiles and TV enthusiasts connect over a shared
        love of entertainment culture. I think it would be right up your street.
      </Typography>

      <Typography variant="body1" paragraph sx={{ textAlign: "justify" }}>
        I'm super proud of what I've done with Curate so far, but with your help
        I think it could be something much more special. I'd really value the
        chance to ask your advice and, if it's of interest, to talk about you
        being properly involved in the business.
      </Typography>

      <Typography variant="body1" paragraph sx={{ textAlign: "justify" }}>
        I will try to follow up via your agent, but if it's easier to reach me
        directly, my email is{" "}
        <Link href="mailto:will@curateapp.io?subject=Re%3A%20Curate">
          will@curateapp.io
        </Link>
        . I'd be delighted to hear from you.
      </Typography>

      <Typography variant="body1" paragraph>
        Kind regards,
        <br />
        Will Blacklock
      </Typography>

      <Typography variant="body1" paragraph sx={{ textAlign: "justify" }}>
        P.S. Thanks for reading this &amp; for doing what you do 🙏 I'm a huuuge
        fan of your books and podcast!
      </Typography>

      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        sx={{ mt: 5, mb: 5 }}
      >
        <Button
          component={ReactRouterLink}
          to="/?redirect=false"
          variant="outlined"
          size="large"
        >
          Take a look at Curate
        </Button>
        <Button
          variant="contained"
          size="large"
          href="mailto:will@curateapp.io?subject=Re%3A%20Curate"
        >
          Email me
        </Button>
      </Stack>
    </Container>
  );
};

export default RichardOsman;
